import { API_URLs } from "../../../../utilities/API_URLs";
import { Http } from "../../../../utilities/axios/http";

export class GateOutService {
    static getGateOutList = async (params?: any) => {
        try {
            return await Http.get(API_URLs.customerRemovalControl.customerRemovalControlUrl, params)
        } catch (error) {
            return error;
        }
    }

    static getGateOutById = async (id: number) => {
        try {
            return await Http.get(`${API_URLs.customerRemovalControl.customerRemovalControlUrl}/${id}`)
        } catch (error) {
            return error;
        }
    }
}